/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { Component, Fragment } from "react";
import { func, bool } from "prop-types";

import Button from "pages/_components/Button";
import Dropdown from "pages/_components/Dropdown";
import { isIOS } from "react-device-detect";
import { resizableRoute } from "pages/_components/Resizable";

class ProductHead extends Component {
    static propTypes = {
        /**
         * back link url
         */
        /**
         * back function, ignored if backLinkTo is specified
         */
        fetchingDownload: bool,
        onClickDownloadPDF: func,
        onClickDownloadXLS: func,
        renderDownload: func,
        handleOptionsClick: func,
        isDesktop: bool.isRequired,
        onClickDownloadCSV: func,
    };

    static defaultProps = {
        onClickDownloadPDF: null,
        onClickDownloadXLS: null,
        renderDownload: null,
        handleOptionsClick: null,
        fetchingDownload: false,
        onClickDownloadCSV: null,
    };

    handleClick = () => {
        const { handleOptionsClick } = this.props;

        if (handleOptionsClick) {
            handleOptionsClick();
        }
        document.activeElement.blur();
    };

    renderMenuOption = () => {
        const { isDesktop, handleOptionsClick } = this.props;

        if (!isDesktop) {
            return (
                handleOptionsClick && (
                    <div className="toolbar-item">
                        <Button
                            className="toolbar-btn toolbar-btn-right view-options"
                            onClick={this.handleClick}
                            image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}
                            label="view more options"
                            block={false}
                            bsStyle="link"
                        />
                    </div>
                )
            );
        }
        return null;
    };

    renderDownloadDropdown = () => {
        const {
            fetchingDownload,
            onClickDownloadPDF,
            onClickDownloadXLS,
            renderDownload,
            isDesktop,
            onClickDownloadCSV,
        } = this.props;

        if (!isDesktop) {
            return null;
        }
        if (renderDownload) {
            return renderDownload(fetchingDownload);
        }
        return (
            <div className="toolbar-item">
                <Dropdown
                    image="images/figma/icon/download.svg"
                    label="global.download"
                    bsStyle="outline btn-lg"
                    fetching={fetchingDownload}
                    pullRight>
                    <Button
                        onClick={onClickDownloadPDF}
                        label="accounts.pdfFile"
                        className="dropdown__item-btn"
                        bsStyle="link"
                    />
                    <Button
                        onClick={onClickDownloadXLS}
                        label="accounts.xlsFile"
                        className="dropdown__item-btn"
                        bsStyle="link"
                    />
                    <Button
                        onClick={onClickDownloadCSV}
                        label="accounts.csvFile"
                        className="dropdown__item-btn"
                        bsStyle="link"
                    />
                </Dropdown>
            </div>
        );
    };

    render() {
        return <Fragment>Please change to use CustomProductHead</Fragment>;
    }
}

export default resizableRoute(ProductHead);
